import useFetch from '@hooks/useFetch';
import { processLessonList } from '@api/hooks/course/utils';
import { emptyObject } from '@constants/empty';

const lessonListMiddleware = (useSWRNext) => (key, fetcher, config) => {
  const swr = useSWRNext(key, fetcher, config);
  const processedprocessLessonListData = swr.data?.processed
    ? swr.data
    : processLessonList(swr.data);

  return {
    ...swr,
    data: processedprocessLessonListData
  };
};

export const getKey = (courseUID, shouldGetExtraInfo = false) =>
  `v2/collection/${courseUID}/items/?limit=600${
    shouldGetExtraInfo ? '&extra_info=True' : ''
  }`;

const useLessonList = (
  courseUID,
  shouldGetExtraInfo = false,
  options = {
    revalidateOnMount: false,
    selector: null,
    fallbackData: undefined
  }
) => {
  const key = getKey(courseUID, shouldGetExtraInfo);

  const {
    data: lessonList,
    isValidating,
    ...rest
  } = useFetch(
    key,
    {},
    {
      use: [lessonListMiddleware],
      revalidateOnMount: options.revalidateOnMount,
      fallbackData: options.fallbackData
    }
  );

  if (options.selector && typeof options.selector === 'function') {
    return options.selector(lessonList || emptyObject);
  }

  return {
    key,
    lessonList: lessonList || emptyObject,
    isValidating,
    ...rest
  };
};

export default useLessonList;
